import { render, staticRenderFns } from "./ButtonsNextPrevious.vue?vue&type=template&id=64e7e3e3&scoped=true"
import script from "./ButtonsNextPrevious.vue?vue&type=script&lang=js"
export * from "./ButtonsNextPrevious.vue?vue&type=script&lang=js"
import style0 from "./ButtonsNextPrevious.vue?vue&type=style&index=0&id=64e7e3e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e7e3e3",
  null
  
)

export default component.exports